import { TypeNomenclature } from '@shared/enums/type-nomenclature';

/** Возвращает строковое значение типа номенклатуры */
export const typeNomenclature = (
  hxid: string,
  isComplex: boolean
): TypeNomenclature => {
  return isComplex
    ? TypeNomenclature.Complex
    : hxid.startsWith('9')
    ? TypeNomenclature.Service
    : TypeNomenclature.Analysis;
};
